export default {
	data() {
		return {
			resizeEventCallbackFunction: "onResize",
		};
	},
	created() {
		window.addEventListener(
			"optimizedResize",
			this[this.resizeEventCallbackFunction]
		);
	},
	beforeDestroy() {
		window.removeEventListener(
			"optimizedResize",
			this[this.resizeEventCallbackFunction]
		);
	},
};
